export default {
    namespaced: true,
    state: {
        showFloatingBasket: false,
        successMessage: null,
    },
    mutations: {
        setShowFloatingBasket(state, value) {
            if (value !== state.showFloatingBasket) {
                state.showFloatingBasket = value;
            }
        },
        setSuccessMessage(state, value) {
            state.successMessage = value;
        },
    },
};